import moment from 'moment'
import { APIFactory } from '../api/api.factory'
import DateService from '../services/DateService'

const TripProfileAPI = APIFactory.get('tripprofile')
const LocationsAPI = APIFactory.get('locations');

export default {
    async getExpenseReport(erID) {
        console.log('TripProfileService.getExpenseReport')

        const { data } = await TripProfileAPI.get(erID);

        //update destinations for client side only fields not returned
        data.trip.destinations.forEach(function (d) {

            //set clientside flag for domestic/foreign toggle
            if (d.foreignLocationId) {
                d.domestic = false;
            }
            else if (d.domesticLocationId) {
                d.domestic = true;
            }
            else {
                d.domestic = 'other';
            }

            //set client side flag for personal single date or date range.
            d.personalDates.forEach(function (pd) {
                if (moment(DateService.normalizeDateTime(pd.startDate)).isSame(DateService.normalizeDateTime(pd.endDate))) {
                    pd.personalRange = true;
                }
                else {
                    pd.personalRange = false;
                }
            })

        })

        return data;
    },
    async getExpenseReportStatus(erID) {
        const { data } = await TripProfileAPI.get(erID);
        console.log('inside status')
        console.log(data.expenseReportStatusTypeId)
        return data;
    },
    async saveExpenseReport(request) {
        console.log('TripProfileService.saveExpenseReport')
        const { data } = await TripProfileAPI.save(request);

        return data;
    },
    async getDomesticLocations() {
        console.log('TripProfileService.getDomesticLocations')
        const { data } = await LocationsAPI.getDomestic();

        return data;
    },

    async getDomesticLocationsByZip(zip) {
        console.log('TripProfileService.getDomesticLocationsByZip')
        const { data } = await LocationsAPI.getDomesticByZip(zip);

        return data;
    },

    async getForeignLocations() {
        console.log('TripProfileService.getForeignLocations')
        const { data } = await LocationsAPI.getForeign();

        return data;
    },

    async getForeignLocationsByCityOrCountry(query) {
        console.log('TripProfileService.getForeignLocationsByCityOrCountry')
        const { data } = await LocationsAPI.getForeignByCityORCountry(query);

        return data;
    },
    async getUSTerritoryLocations() {
        console.log('TripProfileService.getUSTerritoryLocations')
        const { data } = await LocationsAPI.getUSTerritoryByCityOrCountry("");

        return data;
    },
    async getUSTerritoriesByCityOrCountry(query) {
        console.log('TripProfileService.getUSTerritoriesByCityOrCountry')
        const { data } = await LocationsAPI.getUSTerritoryByCityOrCountry(query);

        return data;
    },
    validateExpenseReport(expenseReport) {
        console.log('TripProfileService.validateExpenseReport')
        let errors = [];

        if (!expenseReport.trip.tripName) {
            errors.push('Trip name is required')
        }

        if (_.filter(expenseReport.trip.destinations, ['purpose', null]).length > 0) {
            errors.push('Purpose is required')
        }

        if (_.filter(expenseReport.trip.destinations, ['startDate', null]).length > 0) {
            errors.push('Desitnation start date required')
        }

        if (_.filter(expenseReport.trip.destinations, ['endDate', null]).length > 0) {
            errors.push('Desitnation end date required')
        }

        return errors;
    },

    createSaveRequest(expenseReport) {
        console.log('TripProfileService.createSaveRequest')
        //map vm data to request
        let desinations = expenseReport.trip.destinations.map((d) => {
            return {
                "id": d.id || null,
                "tripId": d.tripId || null,
                "startDate": DateService.normalizeDateTime(d.startDate),
                "endDate": DateService.normalizeDateTime(d.endDate),
                "purpose": d.purpose,
                //only pass up locationID for the search input currently shown. This is driven off domestic flag = true or false.
                "domesticLocationId": d.domestic == true ? d.eventsite.id : null,
                //only pass up locationID for the search input currently shown. This is driven off domestic flag = true or false.
                "foreignLocationId": d.domestic == false ? d.eventsiteForeign.id : null,
                "OtherDomesticLocationId": d.domestic == 'other' ? d.eventsiteOtherDomestic.id : null,
                "personal": d.personal,
                "personalDates": d.personalDates.map((pd) => {
                    if (pd.personalRange) {
                        pd.endDate = null;
                    }

                    return {
                        "startDate": DateService.normalizeDateTime(pd.startDate),
                        "endDate": DateService.normalizeDateTime(pd.endDate) || DateService.normalizeDateTime(pd.startDate), //if no range provided default to startDate
                        "additionalAirport": pd.additionalAirport,//this.additionalAirport, //additional airport setting applies to all personal dates. (should be under destinations)
                        "tripDestinationId": pd.tripDestinationId || null,
                        "id": pd.id || null,
                    }
                })
            }
        })

        let request = {
            "Trip":
            {
                "TripName": expenseReport.trip.tripName,
                "supportingRemark": expenseReport.trip.supportingRemark,
                "Destinations": desinations
            }
        }

        return request;
    }
} 